import { render, staticRenderFns } from "./edu_liyou_course_mng_page.vue?vue&type=template&id=41a810bc"
import script from "./edu_liyou_course_mng_page.vue?vue&type=script&lang=js"
export * from "./edu_liyou_course_mng_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a810bc')) {
      api.createRecord('41a810bc', component.options)
    } else {
      api.reload('41a810bc', component.options)
    }
    module.hot.accept("./edu_liyou_course_mng_page.vue?vue&type=template&id=41a810bc", function () {
      api.rerender('41a810bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/edu_liyou/course/edu_liyou_course_mng_page.vue"
export default component.exports